/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getAllBureauxActions, {
    getAllBureauxTypes,
} from '../../../redux/bureau/getAllBureaux'
import { Get } from '../../../serveur/axios'

function* getAllBureauxSagas({ response }) {
    try {
        const responseAdd = yield Get('bureauemploi/')
        if (responseAdd.status === 200) {
            yield all([
                yield put(getAllBureauxActions.getAllBureauxSuccess(responseAdd.data.data)),
            ])
        }
        else
            yield put(getAllBureauxActions.getAllBureauxFailure(responseAdd.data))

    } catch (error) {
        yield put(getAllBureauxActions.getAllBureauxFailure(error))
    }
}

export function* getAllBureauxSaga() {
    yield takeLatest(
        getAllBureauxTypes.GET_ALL_BUREAUX_REQUEST,
        getAllBureauxSagas
    )
}
